import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Card from '@components/Card/Card';
import Button from '@components/CustomButton';
import { SENTRY } from '@modules/_misc';
import { globalActions } from '@reducers/global';
import withRouter from '@wrappers/withRouter';

const OnError = props => {
	const { navigate, error, resetErrorBoundary } = props,
		dispatch = useDispatch(),
		email = useSelector(state => state.user.email),
		onClearError = () => dispatch(globalActions.captureError()),
		network_err = error?.message?.includes('Network Error');

	useEffect(() => {
		onClearError();
	}, []);

	function onReset(path, objState) {
		SENTRY.set_tag('triggering_app_id', '');
		SENTRY.set_tag('bypass_code', '');
		SENTRY.set_tag('coupon_code', '');
		SENTRY.set_tag('address_string', '');

		navigate(path, objState || {});
		resetErrorBoundary();
	}

	function renderButtons() {
		if (email && !network_err) {
			return (
				<>
					<Button
						variant='info'
						className='back-btn col-centered'
						fill
						onClick={() => onReset('/my-account')}>
						My Account
					</Button>
					<Button
						variant='info'
						className='back-btn col-centered'
						fill
						onClick={() => onReset('/', { state: { logging_out: true } })}>
						Log me Out
					</Button>
				</>
			);
		}

		return (
			<Button variant='info' className='back-btn col-centered' fill onClick={() => onReset('/')}>
				Home
			</Button>
		);
	}

	return (
		<>
			<div className='constellation-bg'></div>
			<div className='wrapper noSidebarWrapper' role='main'>
				<div id='main-panel' className='main-panel noSidebarPanel'>
					<Card content={network_err ? CONTENT.network_err : CONTENT.default} buttons={renderButtons()} />
				</div>
			</div>
		</>
	);
};

const CONTENT = {
	network_err: (
		<>
			<h1>Connection lost</h1>
			<p>Looks like we lost you there. Are you still online?</p>
		</>
	),
	default: (
		<>
			<h1>OOPS!</h1>

			<p>Whatever that was, it certainly wasn&apos;t supposed to happen.</p>

			<p>
				If this your first time seeing this page, please refresh the page and try again. If this issue persists,
				please contact 1-800-442-6459 or <a href='mailto:contact@go.wisconsin.edu'>contact@go.wisconsin.edu</a>{' '}
				for assistance.
			</p>
		</>
	)
};

export default withRouter(OnError);
